import PropTypes from 'prop-types';

export const ViewPropTypes = {
  weekNumber: PropTypes.number.isRequired,
  numberOfDays: PropTypes.number.isRequired,
  analysisDays: PropTypes.number.isRequired,
  currentWeek: PropTypes.number.isRequired,
  onWeekChange: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  onBulkDeleteClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onHideClick: PropTypes.func,
  onBulkHideClick: PropTypes.func,
  disableHover: PropTypes.bool,
  plannedServings: PropTypes.number,
  onProjectedServingsChange: PropTypes.func,
  onProjectedServingsBlur: PropTypes.func,
  onProjectedServingsPercentageChange: PropTypes.func,
  onProjectedServingsPercentageBlur: PropTypes.func,
  selectedRecipesById: PropTypes.object,
  showDaysOfTheWeek: PropTypes.bool,
  showMealContributionReq: PropTypes.bool,
  openRecipe: PropTypes.func,
  contributions: PropTypes.array,
  selectedDays: PropTypes.object,
  currentDay: PropTypes.number,
  onToggleRecipeAlacarte: PropTypes.func,
  recipeCountByDaysMap: PropTypes.object,
  showReimbMealsModal: PropTypes.func,
  onQtyOfPortionChange: PropTypes.func,
  onQtyOfPortionBlur: PropTypes.func,
  menuType: PropTypes.number,
  queryParams: PropTypes.object,
  editableAppliedDays: PropTypes.object,
  copiedRecipesBy: PropTypes.object,
  copiedDays: PropTypes.object,
  lassoMode: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/ViewPropTypes.js